import { useQuery } from 'react-query';
import { OFFLINE } from '../../../../../../../../api/services/mediaPlanning/offline/setup';
import prepareSelectData from '../../../utils/prepareSelectData';
import { getCopyLengths } from '../../../../../../../../api/services/mediaPlanning/offline/copyLengths';
import { useError } from '../../../../../common/Errors/ErrorContext/ErrorContext';

const useCopyLengths = () => {
  const { showError } = useError();

  const { data: response, isFetching } = useQuery({
    queryKey: [OFFLINE, 'copy-lengths'],
    queryFn: () => getCopyLengths(),
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.message || error.message || 'Unknown error';
      showError(errorMessage);
    },
  });

  const copyLengths = response?.data || [];
  const preparedData = prepareSelectData(copyLengths);

  return { data: preparedData, isFetching };
};

export default useCopyLengths;
